import PropTypes from 'prop-types';
import React, { Component } from 'react';
import i18next from "../../i18n";
import { UserContext, commentMaxFileSize, allowedCommentFileExtensions, acceptCommentInputFileString } from '../../constants';
import { getFileAttachmentErrorMessage } from '../helpers/CheckFunctions';
import { getBase64 } from '../helpers/HelperFunctions';
import { showModalDialog, hideModalDialog } from '../ModalDialog';
import { decodeHTMLEntities, encodeHTMLEntities } from '../helpers/HelperFunctions';
import { RichTextEditor } from './RichTextEditor';
export class CommentForm extends Component {
    static contextType = UserContext;
    static propTypes = {
        handleChangeComment: PropTypes.func.isRequired,
        comment: PropTypes.object
    };
    constructor(props) {
        super(props);
        this.state = {};
        if (this.props.comment) {
            Object.keys(this.props.comment).map((key) =>
                this.state[key] = this.props.comment[key]
            );
        }
        if (this.state.content)
            this.state.content = decodeHTMLEntities(this.state.content);
        this.state.withFiles = this.props.withFiles;
        this.state.commentBeanList = [];
        this.state.submitted = false;
        this.state.files = this.props.files ?? [];
        this.state.removedFiles = [];
        this.state.edit = this.props.comment ? true : false
        this.changeComment = this.changeComment.bind(this);
        this.onFileChange = this.onFileChange.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.handleChangeComment = this.handleChangeComment.bind(this);
        this.removeFile = this.removeFile.bind(this);
    }
    onCancel() {
        const { onCloseHandler } = this.props;
        if (!this.state.sending && onCloseHandler)
            onCloseHandler();
    }
    render() {
        const { content, submitted, edit, files, withFiles, newComment } = this.state;
        return (
            <>
                <div className="modal-body">
                    <form name="form" className="popupSimple">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="required">{i18next.t("comment")}</label>
                                    <RichTextEditor onChange={this.changeComment} content={newComment ? content : encodeHTMLEntities(content)} />
                                    {submitted && !content ? <div className="help-block">{i18next.t("requiredField")}</div> : ""}
                                </div>
                            </div>
                        </div>
                        {withFiles &&
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="form-group">
                                        <input type="file" style={{ display: "none" }} id="comment-file-input"
                                            accept={acceptCommentInputFileString}
                                            onChange={this.onFileChange}
                                        />
                                        <div className="comment-attachments-list">
                                            {files.map((file, index) =>
                                                <div className="comment-attachments-item" title={file.fileName}>
                                                    <button type="button" className="close" onClick={() => this.removeFile(index)}>
                                                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="black" />
                                                        </svg>
                                                    </button>
                                                    <div>
                                                        {file.fileName}
                                                    </div>
                                                </div>
                                            )}
                                            <div className="comment-attachments-item last-item"
                                                onClick={() => document.getElementById("comment-file-input").click()}
                                                onChange={this.onFileChange}>
                                                <div>
                                                    {i18next.t("addFileToComment")}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </form>
                </div>
                <div className="modal-footer">
                        <div className="form-group form-group__last">
                        <button className="btn btn-primary" onClick={this.handleChangeComment}>{edit ? i18next.t("save") : i18next.t("add")}</button>
                        <button type="button" className="btn btn-secondary" onClick={this.onCancel}>{i18next.t("cancel")}</button>
                        <div className="required-label">
                            <label className="required" />{i18next.t("requiredFields")}
                        </div>
                    </div>
                </div>
            </>
        );
    }
    changeComment(content) {
        this.setState({
            content: content
        });
    }
    handleChangeComment(e) {
        e.preventDefault();
        const user = JSON.parse(localStorage.getItem('user'));
        const dateTime = new Date().toUTCString();
        const { id, content, userName, commentBeanList, files, removedFiles } = this.state;
        if (this.props.handleChangeComment && content) {
            this.props.handleChangeComment({
                id: id ? id : new Date().getTime(),
                userFullName: user.userName,
                content: content,
                userName: userName,
                created: dateTime,
                position: user.position,
                commentBeanList: commentBeanList,
                files: files ? files.filter(f => f.fileNodeRef === undefined) : [],
                removedFiles: removedFiles
            });
        }
    }
    onFileChange(e) {
        let errorMessage;
        let currentObject = this;
        if (e.target.files && e.target.files.length > 0) {
            let file = e.target.files[0];
            errorMessage = getFileAttachmentErrorMessage(file, allowedCommentFileExtensions, commentMaxFileSize);
            if (errorMessage) {
                document.getElementById("comment-file-input").value = null;
                showModalDialog("loadingDialog", i18next.t("message"), "", <div className="info-message">{errorMessage}</div>, "feedPopup", true, [{ title: i18next.t("ok"), clickHandler: () => hideModalDialog("loadingDialog"), class: "btn-primary" }]);
            }
            else {
                getBase64(file).then(result => {
                    document.getElementById("comment-file-input").value = null;
                    let fileContent = result.content;
                    let extension = file.name.split('.').slice(-1)[0];
                    currentObject.setState({ files: [...this.state.files, { fileValue: fileContent, fileExtension: extension, fileName: file.name, file: file }] });
                })
            }
        }
    }
    removeFile(index) {
        let { files, removedFiles } = this.state;
        if (index > -1 && files.length > index) {

            if (files[index].fileNodeRef !== undefined)
                removedFiles.push(files[index].fileNodeRef);
            files.splice(index, 1);
            this.setState({ files: files });
        }
    }
}
